import { useSWRConfig } from 'swr';
import { ApiResult, useService, wrapErrorWithResult } from '../api';
import { useSubscriptions } from './useSubscriptions';
import { useDeliveryDates } from './useDeliveryDates';
import { useNextDeliveryTarget } from './useNextDeliveryTarget';
import { LegacySubscriptionService } from './service';
import { SUBSCRIPTIONS_V3_BASE_URL } from './constants';

//TODO: This hook will be refined on #WEB-1603
export const useLegacySubscription = (petId, legacy) => {
  const service = useService(LegacySubscriptionService);
  const { mutate } = useSWRConfig();
  const { subscriptions, isLoading: isSubscriptionLoading } =
    useSubscriptions(legacy);
  const subscription = subscriptions?.find(sub => sub.pet_id === petId);
  const { updateDeliveryDates } = useDeliveryDates(subscription?.id);
  const { nextDeliveryDate, isNextDeliveryTargetLoading } =
    useNextDeliveryTarget(subscription, true);

  //TODO: This mutation should be fixed when implementing this hook. Currently this
  //mutate is using SUBSCRIPTIONS_V3_BASE_URL as key
  const mutateLegacySubscription = data => {
    return mutate(
      SUBSCRIPTIONS_V3_BASE_URL,
      {
        data: subscriptions.map(sub =>
          sub.id === subscription.id ? data : sub,
        ),
      },
      false,
    );
  };

  const updateLegacySubscription = async data => {
    try {
      const response = await service.updateLegacySubscription(
        subscription.id,
        data,
      );
      await updateDeliveryDates();
      await mutateLegacySubscription(response.data);
      return ApiResult.success(response);
    } catch (error) {
      return wrapErrorWithResult(error);
    }
  };

  const legacySkipNextDelivery = async () => {
    try {
      const response = await service.legacySkipNextDelivery(subscription.id);
      mutateLegacySubscription(response.data);
      return ApiResult.success(response);
    } catch (error) {
      return wrapErrorWithResult(error);
    }
  };
  const reactivateLegacyPlan = async (couponCode, campaignId) => {
    try {
      const response = await service.reactivateLegacyPlan(
        subscription.id,
        couponCode,
        campaignId,
      );
      mutateLegacySubscription(response.data);
      return ApiResult.success(response);
    } catch (error) {
      return wrapErrorWithResult(error);
    }
  };
  return {
    subscription,
    isLoading: isSubscriptionLoading || isNextDeliveryTargetLoading,
    nextDeliveryDate,
    updateLegacySubscription,
    legacySkipNextDelivery,
    reactivateLegacyPlan,
  };
};
